// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__107s4","productName":"Table_productName__6oASx"};